
// displays shimmer while content loads in /pooja page
const Shimmer = () => {
    return (
        <div>
            <div className="mx-auto w-full  rounded-lg   md:h-[500px] h-[400px]     bg-gray-200 max-w-[500px]">
                <div className="flex animate-pulse space-x-4">
                    <div className="flex-1 space-y-6 py-1">
                        <div className="h-2 rounded bg-gray-200"></div>
                        <div className="space-y-3">
                            <div className="grid grid-cols-3 gap-4">
                                <div className="col-span-2 h-2 rounded bg-gray-200"></div>
                                <div className="col-span-1 h-2 rounded bg-gray-200"></div>
                            </div>
                            <div className="h-2 rounded bg-gray-200"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-5 rounded-lg mt-8 w-full bg-gray-200 "></div> 
            <div className="h-5 rounded-lg mt-3 w-1/2 bg-gray-200 "></div> 
            <div className="h-5 rounded-lg mt-5 w-1/4 bg-gray-200 "></div> 
        </div>
    )
}

export default Shimmer;